import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import {
  useRecoilState,
} from 'recoil';
import { LinkItem, LinkList } from "../../../../components/links/Links";
import UserAvatar from "../../../../components/user/UserAvatar";
import { Types, useUser } from '../../../../context/user';
import { clientAtom } from '../../../../state';

const User = () => {
  const {
    state: {
      user,
    },
    dispatch: dispatchUser
  } = useUser();
  const [client] = useRecoilState(clientAtom);
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prevState) => !prevState);

  const onLogout = () => {
    dispatchUser({
      type: Types.LOGOUT,
      item: {}
    });
    toggle();

  }
  return (

    user
      ?
      <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
        <DropdownToggle
          tag="a"
          href="#toggle"
          className="dropdown-toggle"
          onClick={(ev) => {
            ev.preventDefault();
          }}
        >
          <div className="user-toggle">
            <UserAvatar icon="user-alt" className="sm" />
            <div className="user-info d-none d-xl-block">
              <div
                className={`user-status`}
              >
                {user.name}
              </div>
              <div className="user-name dropdown-indicator">{client.name}</div>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu right className="dropdown-menu-md dropdown-menu-s1">
          <div className="dropdown-inner">
            <LinkList>
              <LinkItem
                link={'/profile'}
                icon="setting-alt"
                onClick={toggle}
              >
                Thông tin tài khoản
              </LinkItem>
            </LinkList>
          </div>
          <div className="dropdown-inner">
            <LinkList>
              <LinkItem
                link={`/`}
                icon="signout"
                onClick={onLogout}
              >
                <span>Đăng xuất</span>
              </LinkItem>
            </LinkList>
          </div>
        </DropdownMenu>
      </Dropdown>
      : <Link className="btn btn-primary p-1" to={`/login`}>Đăng nhập</Link>
  );
};

export default User;
